require('./style.css');
var tmpl = require('./main.ejs');

var Poster = function (url) {
  this.url = url;
  this.init();
};

Poster.prototype.init = function () {
  this.initDom();
  this.initEvent();
};

Poster.prototype.initDom = function () {
  var div = document.createElement('div');
  div.innerHTML = tmpl({url: this.url});
  this.el = div.children[0];
};

Poster.prototype.initEvent = function () {
};

Poster.prototype.hide = function () {
  this.el.style.display = 'none';
};

Poster.prototype.show = function () {
  this.el.style.display = 'block';
};

Poster.prototype.renderTo = function (parentNode) {
  parentNode.appendChild(this.el);
};

Poster.prototype.destory = function () {
  this.el.parentNode.removeChild(this.el);
};


module.exports = Poster;


// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.compenont.video.mobile/app/modules/poster/index.js